
import { Component, Prop, Provide, Vue, Watch } from 'vue-property-decorator'
import AmMap from '@/components/AmMap/index.vue'
import { dateFormat, dashedVid } from '@/utils/index'
import ParameterItem from '@/components/TrackInfo/parameterItem.vue'
import '@/components/ProductInfo/index.scss'
import SectionCom from '@/components/MeterialInfo/section.vue'

@Component({
  components: {
      AmMap,
      ParameterItem,
      SectionCom
  },
  filters:{}
})
export default class Test extends Vue {
  
  /// props
  @Prop() private landingInfo!: any
  @Prop({default: () => {
    return []
  }}) private additionDcuList!: Array<any>

  private get trackinfo(): Array<any> {
    let { trackinfo } = this.landingInfo
    console.log("trackinfo,",trackinfo)
    return trackinfo || []
  }

  private get parameters(): Array<any> {

      let { batch } = this.landingInfo
      
      /// 原料接受信息
      let meterialInfoList = batch && batch.custom && batch.custom.Materialinformation || []
      meterialInfoList = meterialInfoList.map((item: any) => {
          return {
            previewIndex: 0,
            textplain_001: item.ParameterName,
            textplain_002: item.Parametervalue
          }
      })

      /// 原料接收日期
      let meterialDateList = batch && batch.custom && batch.custom.Materialdate || []
      meterialDateList = meterialDateList.map((item: any) => {
          return {
            previewIndex: 0,
            textplain_001: item.ParameterName1,
            textplain_002: item.Parameterdate && dateFormat(item.Parameterdate, 'yyyy-MM-dd') || ''
          }
      })

      /// 原料接收报告
      let meterialReportList = batch && batch.custom && batch.custom.Materialreport || []
      meterialReportList = meterialReportList.map((item: any) => {
          return {
            previewIndex: new Date().getTime(),
            textplain_001: item.ParameterName2,
            mediaimg_001: item.otherlist_010 && item.otherlist_010.map((image: any)=>{
                return image.filelocation
            })
          }
      })

      /// 批次信息
      let batchInformationList = batch && batch.custom && batch.custom.Productionbatch || []
      batchInformationList = batchInformationList.map((item: any) => {
          return {

            previewIndex: 0,
            textplain_001: item.ParameterName3,
            textplain_002: item.Parametervalue3
          }
      })

      /// 生产日期/包装日期
      let batchDateList = batch && batch.custom && batch.custom.Batchdate || []
      batchDateList = batchDateList.map((item: any) => {
          return {

            previewIndex: 0,
            textplain_001: item.ParameterName4,
            textplain_002: item.Parametervalue4 && dateFormat(item.Parametervalue4, 'yyyy-MM-dd') || ''
          }
      })

      /// 检测报告
      let batchReportList = batch && batch.custom && batch.custom.Batchreport || []
      batchReportList = batchReportList.map((item: any) => {
          return {
            previewIndex: new Date().getTime(),
            textplain_001: item.ParameterName5,
            mediaimg_001: item.otherlist_013 && item.otherlist_013.map((image: any)=>{
                return image.filelocation
            })
          }
      })

     return [...meterialInfoList,
             ...meterialDateList, 
             ...meterialReportList, 
             ...batchInformationList,
             ...batchDateList, 
             ...batchReportList]
  }

  private get headTitle(): any {
    if(this.landingInfo && this.landingInfo.customizedLp){
      let {custom} = this.landingInfo.activity
      return custom.textplain_017 || this.$t('app.track_head')
    }
    return this.$t('app.track_head')
  }

  private get locations(): Array<any> {
      let { trackinfo } = this.landingInfo
      let sortedTrackInfo = trackinfo.sort((a: any, b: any) => {
        return a.base.timestamp - b.base.timestamp
      })
      return sortedTrackInfo && sortedTrackInfo.map((item: any) => {
        return item.custom && item.custom.gps
      }) || []
  }

  private get dashedTxid(): string {
    //   dashedVid
    let {batch} = this.landingInfo
    let txId = batch && batch.blockinfo && batch.blockinfo.txId || ""
    return dashedVid(txId)
  }

  private openTxRecord() {
      let {batch, explorerUrl} = this.landingInfo
      let txId = batch && batch.blockinfo && batch.blockinfo.txId || ""
      // txId && window.open(explorerUrl + "/transactions/" + txId)
      // this.$router.push({name: "BlockDetail",  query: {txId: txId}})
      if(document.domain.endsWith(".cn")){
        this.$router.push({name: "BlockDetail",  query: {txId: txId}})
      }else{
        txId && window.open(explorerUrl + "/transactions/" + txId)
      }
  }

  private viewDetail(item: any, index: number) {
    console.log("viewDetail", item)
    this.$store.state.record = item
    this.$store.state.recordAdditionDcu = this.additionDcuList[index]
    this.$router.push({name: 'DcpDetail', query: {type: 'track'}})
  }
  private get trackCountTitle(): string {

    if(this.trackinfo && this.trackinfo.length > 1){
      return `${this.trackinfo.length}` + this.$t('app.custom_records_multi')
    }else{
      return `${this.trackinfo.length}` + this.$t('app.custom_records_single')
    }
  }
  /// lifecycle
  created() {
    
  }
  
  mounted() {
    
  }
  
  /// methods
  public methodOne(params: any): void {
    
  }
  /// watch methods
  @Watch('newList', { immediate: true, deep: true })
  onArrayChanged(newVal: any, oldVal: any) {
    
  }
}
